import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { useListActivitiesQuery, useUpdateIroMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'IroActivity',
  props: {
    value: null,
    iroId: null,
    valueChainId: null
  },
  setup: function setup(__props) {
    var props = __props;
    var _useListActivitiesQue = useListActivitiesQuery(computed(function () {
        return {
          filters: {
            valueChainIds: props.valueChainId ? [props.valueChainId] : []
          }
        };
      })),
      activitiesResult = _useListActivitiesQue.result,
      loading = _useListActivitiesQue.loading;
    var activities = computed(function () {
      var _activitiesResult$val, _activitiesResult$val2;
      return (_activitiesResult$val = activitiesResult.value) === null || _activitiesResult$val === void 0 ? void 0 : (_activitiesResult$val2 = _activitiesResult$val.listActivities) === null || _activitiesResult$val2 === void 0 ? void 0 : _activitiesResult$val2.map(function (v) {
        return {
          text: v.name,
          value: v.id
        };
      });
    });
    var _useUpdateIroMutation = useUpdateIroMutation(),
      updateIRO = _useUpdateIroMutation.mutate;
    return {
      __sfc: true,
      props: props,
      activitiesResult: activitiesResult,
      loading: loading,
      activities: activities,
      updateIRO: updateIRO
    };
  }
});